import * as React from 'react';
import { Switch, Route } from 'react-router';
import { AddAssignWork } from './AddAssignWork';
import { AssignWorkList } from './AssignWorkList';
import { FinishedWorkList } from './FinishedWorkList';

export class AssignWork extends React.Component<{}, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path='/dashboard/assign_work' component={AssignWorkList} />
        <Route path='/dashboard/assign_work/add' component={AddAssignWork} />
        {/* <Route path='/dashboard/assign_work/:id' component={EditAssignWork} /> */}
        <Route path='/dashboard/assign_work/finished_work' component={FinishedWorkList} />
      </Switch>
    );
  }
}
